export default "__VITE_PUBLIC_ASSET__aad7a70a__"